import React from 'react'
import App from '../../../components/app/App'
import PasswordChange from './PasswordChange'

export default () => (
    <App>
        <PasswordChange />
    </App>
)
